import moment, { Moment } from "moment";

export type JobState = "pending" | "in-progress" | "failed" | "successful";

export interface JobDTO {
  id: number;
  log: string;
  state: JobState;
  createdAt: string;
  finishedAt: string;
  startedAt: string;
}

export class Job {
  private _id: number;
  private _log: string;
  private _state: JobState;
  private _createdAt: Moment;
  private _finishedAt: Moment;
  private _startedAt: Moment;

  static create(job: JobDTO): Job {
    return new Job(job);
  }

  constructor(job: JobDTO) {
    this._id = job.id;
    this._log = job.log;
    this._state = job.state;
    this._createdAt = moment(job.createdAt);
    this._finishedAt = moment(job.finishedAt);
    this._startedAt = moment(job.startedAt);
  }

  public get log() {
    return this._log;
  }

  public get state() {
    return this._state;
  }

  public get createdAt() {
    return this._createdAt.format("DD.MM.YYYY");
  }

  public get finishedAt() {
    return this._finishedAt.format("DD.MM.YYYY");
  }

  public get startedAt() {
    return this._startedAt.format("DD.MM.YYYY");
  }
}
